import {VisitAPIDataSource} from '../api/VisitAPIDataSource';
import {mapVisitDTOToModel} from '../mappers/visit.mapper';
import {Visit} from '../models/visit.model';

export class GetStoreApprovedVisitsUseCase {
  async execute (storeId: string | number): Promise<Visit[]> {
    const dtos = await VisitAPIDataSource.getStoreApprovedVisits(storeId);
    return dtos.map(dto => mapVisitDTOToModel(dto));
  }
}
